import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=67e9f55e&scoped=true&"
import script from "./ServiceCard.vue?vue&type=script&lang=js&"
export * from "./ServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=67e9f55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9f55e",
  null
  
)

export default component.exports